// React
import { type ReactNode, type Ref, type ButtonHTMLAttributes } from "react"

// UI primitives
import { FieldTrigger } from "@/components/ui/field-trigger"

// Icons
import { ChevronDownIcon } from "@/react/components/icons/ChevronDownIcon"

// Hooks and utilities
import { cn } from "@/lib/utils"

export interface DropdownTriggerProps {
  selectedLabel?: ReactNode
  placeholder: string
  isOpen: boolean
  invalid?: boolean
  className?: string
  ref?: Ref<HTMLButtonElement>
}

export function DropdownTrigger({
  selectedLabel,
  placeholder,
  isOpen,
  invalid = false,
  className,
  ref,
  ...props
}: DropdownTriggerProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  const invalidContainerClasses = invalid &&
    "bg-chilli-blush border-chilli-red-light hover:border-chilli-red-light"
  const labelColorClass = selectedLabel ? "text-off-black" : "text-grey-light"
  const chevronColorClass = invalid ? "text-chilli-red" : "text-off-black"

  return (
    <FieldTrigger
      ref={ref}
      role="combobox"
      aria-expanded={isOpen}
      className={cn(invalidContainerClasses, className)}
      {...props}
    >
      <span
        className={cn("truncate min-w-0", labelColorClass)}
        title={typeof selectedLabel === "string" ? selectedLabel : undefined}
      >
        {selectedLabel ?? placeholder}
      </span>
      <ChevronDownIcon
        aria-hidden="true"
        className={cn(
          "shrink-0 transition-transform",
          chevronColorClass,
          isOpen && "rotate-180",
        )}
      />
    </FieldTrigger>
  )
}
